angular.module('picmonicng').directive('learnBackground', [
  '$state',
  '$q',
  function ($state, $q) {
    return {
      restrict: 'E',
      scope: {
        playerService: '=',
        size: '@',
      },
      template:
        '<img class="background" ng-src="{{playerService.currentCard.background_image_url.replace(\'picmonic_assets\',\'picmonic_assets\' + sizeSuffix)}}" ng-show="playerService.backgroundVisible != false"/>',
      controller: [
        '$scope',
        'UserService',
        function ($scope, UserService) {
          $scope.UserService = UserService;
        },
      ],
      link: function (scope, element, attrs) {
        var assetStatus = $q(function (resolve, reject) {
          var img = element.find('img')[0];
          if (!img.src) {
            resolve();
            return;
          }
          var image = new Image();

          image.addEventListener('load', function () {
            resolve();
          });

          image.addEventListener('error', function (e) {
            reject();
          });
          image.src = img.src;
        });
        scope.playerService.assetStatus.push(assetStatus);

        switch (scope.size) {
          case 'md':
            scope.sizeSuffix = '_threequarter';
            break;
          case 'sm':
            scope.sizeSuffix = '_half';
            break;
          case 'xs':
            scope.sizeSuffix = '_quarter';
            break;
        }

        if (scope.playerService.getSlowSpeedMode && scope.playerService.getSlowSpeedMode()) {
          scope.sizeSuffix = '_quarter';
        }
      },
    };
  },
]);
